<template>
  <v-layout row fluid>
          <v-expansion-panel
            class="tasklist-expander mb-3 p-relative parent-expansion rounded-3"
            v-bind:class="{ withRemove: !tasklist.templated }"
            >
             <div class="horiz-left-coloured-bg">
                    <v-icon color="secondary" class="mt-0 ml-2 horiz-left-coloured-bg--icon">done_all</v-icon>
              </div>
              <v-expansion-panel-content class="rounded-3">
                <div slot="header" class="tasklist-name-header">
                  <h3
                    v-show="tasklistTitle"
                    class="text-truncate py-1 ml-2 pl-4 horiz-left-coloured-bg--padding-header tasklist-name">
                  {{tasklist.name}} ({{tasklist.tasks.length}})
                  </h3>
                  <v-tooltip left color="secondary" v-if="!tasklist.templated && tasklistTitle">
                    <v-btn slot="activator" class="tasklist-name-edit-btn " @click.stop v-on:click.exact="editTasklist()" icon><v-icon small>edit</v-icon></v-btn>
                  <span>Edit Tasklist name</span>
                  </v-tooltip>

                  <div v-show="tasklistTitleEdit" class="horiz-left-coloured-bg--padding tasklist-name-edit-field">
                  <v-text-field
                    class="pl-0 ml-4"
                    v-model="tasklistName" label="Tasklist name"
                    solo flat @click.stop>
                  </v-text-field>
                  <v-btn @click.stop="updateTasklist()" style="position:absolute;top:3px; right:-55px;" icon>
                    <v-icon color="success">done</v-icon>
                  </v-btn>
                  <v-btn
                    icon @click.stop v-on:click.exact="cancelEdit()"
                    style="position:absolute;top:3px; right:-90px;">
                    <v-icon color="error">clear</v-icon>
                  </v-btn>
                </div>

                  <v-btn
                      class="remove-icon"
                      icon v-if="!tasklist.templated" @click.stop="dialogTasklistDelete = true">
                      <v-icon color="error">cancel</v-icon>
                    </v-btn>
                    <v-dialog v-model="dialogTasklistDelete" max-width="500">
                      <v-card class="pa-4">
                        <v-card-title class="pa-0 pb-2">
                          <h2>Are you sure you want to delete this tasklist?</h2>
                        </v-card-title>
                        <v-card-text class="pa-0">
                          <p>This will also delete all tasks within this tasklist.</p>
                        </v-card-text>
                        <v-card-actions class="ma-0 pa-0 pt-1">
                          <v-btn @click="deleteTasklist()" color="error">Yes, delete this tasklist</v-btn>
                          <v-btn @click="dialogTasklistDelete = false" color="secondary">Cancel</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                </div>
                <v-layout class="horiz-left-coloured-bg--padding">
                  <v-flex pr-4 pl-4 pb-4>
                  <v-divider></v-divider>
                      <CaseTaskItem v-for="(task, index) in orderedTasks" :key="index" :task="task" :index="index"></CaseTaskItem>
                      <v-btn v-if="!creatingTask" @click="creatingTask = true" color="secondary" class="ml-0 mt-3">Add a task</v-btn>
                      <form v-if="creatingTask">
                      <v-layout wrap row class="pa-4 mt-4 rounded-3 form-grey-background" >
                        <v-flex xs12 md6 mt-2>
                          <v-text-field v-model="newTaskName" label="Task name" box></v-text-field>
                          <v-textarea v-model="newTaskDescription" box label="Task description"></v-textarea>
                        </v-flex>
                        <v-flex xs12>
                          <h4 class="pb-1">Schedule</h4>
                          <v-layout row>
                              <v-autocomplete
                                clearable
                                box dense class="pr-2"
                                label="Schedule Type"
                                v-model="newTaskScheduleType"
                                :items="scheduleItems"
                                clear-icon="cancel"
                                append-icon="keyboard_arrow_down"
                                style="max-width:200px"
                                >
                              </v-autocomplete>
                              <DateField
                                v-if="newTaskScheduleType"
                                :field="{ name: newTaskScheduleType }"
                                :data="newTaskScheduleDate"
                                v-on:update-item="updateSchedule">
                              </DateField>
                              <v-flex mx-4></v-flex>
                              <v-flex v-if="!newTaskScheduleType" mx-4></v-flex>
                          </v-layout>

                        </v-flex>
                        <v-layout wrap>
                          <v-flex xs12 ma-0 pa-0>
                            <h4 class="pb-1">Assign to a team/user</h4>
                            <v-flex xs12 md6 mt-2>
                              <v-autocomplete
                              clearable
                              clear-icon="cancel"
                              class="white-box-field" box dense
                              label="Select a team" no-data-text="Nothing matching your search"
                              v-model="newTaskTeam"
                              :items="allTeams"
                              append-icon="keyboard_arrow_down"
                              item-text="displayName" item-value="id">
                              <template slot="selection" slot-scope="data">
                                <v-chip
                                  class="white--text chip-team share-chip" close
                                  :class="(data.item.group)"
                                  :selected="data.selected"
                                  @input="newTaskTeam = ''"
                                  color="secondary">
                                  <v-avatar style="opacity:1;"><v-icon dark small>people</v-icon></v-avatar>
                                  {{data.item.displayName}}
                                </v-chip>
                              </template>
                            </v-autocomplete>
                            </v-flex>
                          </v-flex>
                          <v-flex xs12 ma-0 pa-0 v-if="newTaskTeam !== ''">
                            <h4 class="pb-1">Select a specific user from this team</h4>
                            <v-layout wrap>
                              <v-flex xs12 md6 mt-2>
                                <v-autocomplete
                                  clear-icon="cancel"
                                  clearable
                                  class="white-box-field"
                                  box dense
                                  label="Select a user" no-data-text="Nothing match your search"
                                  v-model="newTaskUser"
                                  :items="teamMembers"
                                  item-text="displayName" item-value="id"
                                  append-icon="keyboard_arrow_down">
                                  <template slot="selection" slot-scope="data">
                                    <v-chip
                                      class="white--text share-chip" close
                                      :selected="data.selected"
                                      :class="(data.item.group)"
                                      @input="newTaskUser = ''"
                                      color="secondary">
                                      <v-avatar v-if="data.item.avatar"> <img :src="data.item.avatar"/></v-avatar>
                                      <v-avatar v-if="data.item.avatar == false">{{data.item.initials}}</v-avatar>
                                      <v-avatar v-if="data.item.group == 'chip-team'" style="opacity:1;">
                                        <v-icon dark small>people</v-icon>
                                      </v-avatar>
                                      {{ data.item.displayName }}
                                    </v-chip>
                                  </template>
                                </v-autocomplete>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <v-flex xs12>
                          <v-btn class="ml-0" color="success" :disabled="!newTaskReady" @click="createNewTask()">Save Task</v-btn>
                          <v-btn color="error" v-on:click="creatingTask = false">Cancel</v-btn>
                        </v-flex>
                        </v-layout>
                      </form>
                  </v-flex>
                </v-layout>
              </v-expansion-panel-content>
            </v-expansion-panel>
  </v-layout>
</template>

<script>
import CaseTaskItem from "@/components/cases/case-edit/CaseTaskItem"
import DateField from "@/components/cases/case-elements/DateField"
import Helpers from "@/helpers.js"
import { mapState } from "vuex"

export default {
  name: "CaseTasklist",
  components: { CaseTaskItem, DateField },
  props: { tasklist: { type: Object, required: true } },
  data: () => ({
    on: false,
    dialogTasklistDelete: false,
    creatingTask: false,
    tasklistName: "",
    newTaskName: "",
    newTaskDescription: "",
    newTaskTeam: "",
    newTaskUser: "",
    newTaskScheduleType: "",
    newTaskScheduleDate: new Date().toISOString(),
    scheduleItems: ["At", "By"],
    tasklistTitle: true,
    tasklistTitleEdit: false
  }),
  computed: {
    ...mapState({
      allUsers: state => (state && state.users && state.users.all) ? state.users.all : [],
      allTeams: state => (state && state.teams && state.teams.all) ? state.teams.all : []
    }),
    teamMembers() {
      const members = []
      if (this.newTaskTeam) {
        const teamNames = this.allTeams.map(team => team.id)
        const currentIndex = teamNames.indexOf(this.newTaskTeam)
        const userIds = this.allUsers.map(user => user.id)
        this.allTeams[currentIndex].users.forEach(user => {
          const userIndex = userIds.indexOf(user.id)
          members.push(this.allUsers[userIndex])
        })
      }
      return members
    },
    newTaskReady() {
      return this.newTaskName && this.newTaskDescription
    },
    orderedTasks() {
      if(this.tasklist && this.tasklist.tasks && Array.isArray(this.tasklist.tasks)) {
        Helpers.orderItemsByPosition(this.tasklist.tasks)
        return this.tasklist.tasks
      } else {
        return []
      }
    }
  },
  methods: {
    async createNewTask() {
      const newTask = {
        caseTasklistId: this.tasklist.id,
        name: this.newTaskName,
        description: this.newTaskDescription,
        position: this.tasklist.tasks.length
      }
      if (this.newTaskScheduleType) {
        newTask.taskSchedule = {
          scheduledBy: this.newTaskScheduleType.toLowerCase(),
          scheduledTime: new Date(this.newTaskScheduleDate)
        }
      }
      if (this.newTaskTeam) {
        newTask.assignedTo = {
          assignedToTeamId: this.newTaskTeam,
          assignedToUserId: this.newTaskUser
        }
      }
      await this.$store.dispatch("createCaseTask", newTask)
      this.clearNewTask()
    },
    clearNewTask() {
      this.newTaskName = ""
      this.newTaskDescription = ""
      this.newTaskScheduleType = null
      this.newTaskTeam = null
      this.newTaskUser = null
      this.creatingTask = false
    },
    updateSchedule(value) {
      this.newTaskScheduleDate = new Date(value.data).toISOString()
    },
    editTasklist() {
      this.tasklistName = this.tasklist.name
      this.tasklistTitleEdit = true
      this.tasklistTitle = false
    },
    cancelEdit() {
      this.tasklistName = this.tasklist.name
      this.tasklistTitleEdit = false
      this.tasklistTitle = true
    },
    async updateTasklist() {
      const updatedTasklist = this.tasklist
      updatedTasklist.name = this.tasklistName
      this.$store.dispatch("updateCaseTasklist", updatedTasklist)
      this.tasklistTitleEdit = false
      this.tasklistTitle = true
    },
    async deleteTasklist() {
      this.$store.dispatch("deleteCaseTasklist", this.tasklist.id)
      this.dialogTasklistDelete = false
    }
  }

}
</script>
